import OrderPage from "./OrderPage";

export default function HistoryOrderPage() {
    return <OrderPage historyOnly />;
}
